import { FullCenterContentComponent } from "components/FullCenterContent";
import { RotateScreenIconComponent } from "components/svgIcons/RotateScreen"
import React, { useEffect } from "react";
import "./styles.scss";


export function RotateModalComponent({children}) {

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => document.body.style.overflow = 'auto';
    }, []);

    return (
        <section className="modal rotate-modal">

            <FullCenterContentComponent>
                <div className="modal-content-wrapper">
                    <div className="rotate-device">
                        <RotateScreenIconComponent />
                        <div className="message">Por favor, rodar o dispositivo.</div>
                    </div>
                </div>
            </FullCenterContentComponent>

            <div className="backdrop"></div>
        </section>
    );
};